import React from "react";
import { COLORS } from "../../../common/consts/colors";
import type { IconProps } from "./type";

const SleapLogo = ({ color = "darkGreen" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.31167 0.609526C6.93074 0.296818 7.24028 0.140464 7.56524 0.078947C7.85303 0.0244656 8.14849 0.0244656 8.43628 0.078947C8.76124 0.140464 9.07078 0.296818 9.68986 0.609527L12.8922 2.22708L10.6559 3.8806C9.88159 3.43035 8.97263 3.17108 8.0004 3.17108C5.17162 3.17108 2.87845 5.36598 2.87845 8.07352C2.87845 9.20464 3.27867 10.2463 3.95097 11.0758L2.2825 13.4987C1.88598 13.2901 1.63996 13.1368 1.44525 12.9368C1.20401 12.6891 1.02063 12.391 0.908288 12.064C0.78125 11.6942 0.78125 11.2758 0.78125 10.439L0.78125 5.70785C0.781251 4.87099 0.781251 4.45255 0.908288 4.08278C1.02063 3.75576 1.20401 3.45769 1.44525 3.20997C1.71803 2.92986 2.09152 2.7412 2.8385 2.36389L6.31167 0.609526ZM5.9844 12.5816L3.03271 13.881L6.31166 15.5373C6.93074 15.85 7.24028 16.0063 7.56524 16.0679C7.85303 16.1223 8.14849 16.1223 8.43628 16.0679C8.76124 16.0063 9.07077 15.85 9.68984 15.5373L9.68985 15.5373L9.68986 15.5373L13.163 13.7829C13.91 13.4056 14.2835 13.2169 14.5563 12.9368C14.7975 12.6891 14.9809 12.391 15.0932 12.064C15.2203 11.6943 15.2203 11.2758 15.2203 10.439L15.2203 5.70785C15.2203 4.87099 15.2203 4.45256 15.0932 4.08278C14.9809 3.75576 14.7975 3.45769 14.5563 3.20997C14.3528 3.00102 14.0933 2.84296 13.6645 2.61953L12.5341 5.79032C12.9097 6.4722 13.1224 7.24909 13.1224 8.07352C13.1224 10.7811 10.8292 12.976 8.0004 12.976C7.28461 12.976 6.60312 12.8354 5.9844 12.5816Z"
        fill={COLORS[color]}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.4219 2.19026L6.19795 6.21956C6.14613 6.2531 6.10264 6.29949 6.07116 6.35479L2.29021 12.9962C2.08511 13.3564 2.47046 13.7684 2.80809 13.5499L9.03204 9.52057C9.08386 9.48702 9.12735 9.44064 9.15883 9.38534L12.9398 2.74398C13.1449 2.3837 12.7595 1.97168 12.4219 2.19026ZM7.43316 8.63433C7.83858 8.74296 8.25942 8.48697 8.37314 8.06257C8.48686 7.63817 8.25039 7.20606 7.84497 7.09743C7.43955 6.9888 7.01871 7.24478 6.90499 7.66918C6.79128 8.09358 7.02774 8.52569 7.43316 8.63433Z"
        fill={COLORS[color]}
      />
    </svg>
  );
};

export default SleapLogo;
